<span [popoverTitle]="title|translate" [ngbPopover]="fullText" [placement]="placement">

  <span small-text class="text-gray tw-text-sm" data-toggle="tooltip"
    [matTooltip]="isShowClickToShowMessage()? ('common.clickToShow' | translate):''">
    <ng-content select="[small-text]"></ng-content>
  </span>

</span>

<ng-template #fullText>
  <div *ngIf="isShowClickToShowMessage()" class="full-text-display font-vazir-ui tw-w-[250px] "
  [ngClass]="{'dir-rtl': direction=='rtl','dir-ltr': direction=='ltr'}" data-toggle="tooltip" [class]="customClass" copyToClipboard >
    <ng-content select="[full-text]"></ng-content>
  </div>
</ng-template>
